<a *ngIf="isUserLoggedIn()" (click)="openModal();"><!-- {{"copy.label.LOGOUT.logout"|copy|async}} --><i class="fas fa-sign-out-alt"></i></a>
